export default function() {
  return new Worker(__webpack_public_path__ + "js/main.f5da45d2.worker.js");
}
